import { render, staticRenderFns } from "./TeamNote.vue?vue&type=template&id=4a9813ca&"
import script from "./TeamNote.vue?vue&type=script&lang=js&"
export * from "./TeamNote.vue?vue&type=script&lang=js&"
import style0 from "./TeamNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports